import { AxiosResponse } from 'axios';
import { client } from '../../shared/services/client';
import { CompensationRateReadDto, CompensationRateDto } from '../compensation-rate/model/CompensationRate';

const accountingBaseKey = 'accounting';

class AccountingAPI {
    static getCompensationRates = async (): Promise<CompensationRateReadDto[]> => {
        client.setBaseURLForService(accountingBaseKey);
        const res: AxiosResponse<CompensationRateReadDto[]> = await client.get('/api/CompensationRate');
        return res.data;
    };

    static createCompensationRate = async (dto: CompensationRateDto): Promise<CompensationRateDto> => {
        client.setBaseURLForService(accountingBaseKey);
        const res: AxiosResponse<CompensationRateDto> = await client.post('/api/CompensationRate', dto);
        return res.data;
    };

    static updateCompensationRate = async (id: string, dto: CompensationRateDto): Promise<CompensationRateDto> => {
        client.setBaseURLForService(accountingBaseKey);
        const res: AxiosResponse<CompensationRateDto> = await client.put(`/api/CompensationRate/${id}`, dto);
        return res.data;
    };

    static deleteCompensationRate = async (id: string): Promise<void> => {
        client.setBaseURLForService(accountingBaseKey);
        await client.delete(`/api/CompensationRate/${id}`);
    };
}

export default AccountingAPI;
